import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { ApiSubWorkOrderDto } from '../dto/sub-work-order.dto';
import { API_ENDPOINTS } from '../../../core/providers/constants/api.constants';
import { SubWorkOrder } from '../types/sub-work-order';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteSubWorkOrderService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }
  urlRoute = `${API_ENDPOINTS.SUB_ORDER}`;

  getByWorkOrder(workOrderId: number): Observable<any> {
    return this.http.get(`${this.urlRoute}/${workOrderId}/report`);
  }

  getByTypeAndStage(typeId: number, query: string = ''): Observable<any> {
    return this.http.get(
      `${this.urlRoute}/${typeId}/stage${query ? `?${query}` : ''}`
    );
  }

  getSubWorkOrdersByTypeAndStage(
    typeId: number,
    stageId: number
  ): Observable<SubWorkOrder[]> {
    return this.http.get<SubWorkOrder[]>(
      `${this.urlRoute}/${typeId}/stage/${stageId}`
    );
  }

  update(id: number, body: {}): Observable<SubWorkOrder> {
    return this.http.patch<SubWorkOrder>(`${this.urlRoute}/${id}`, body);
  }

  updateWorkOrderRank(
    subWorkOrderId: number,
    rank: string
  ): Observable<SubWorkOrder> {
    return this.http.patch<SubWorkOrder>(
      `${this.urlRoute}/${subWorkOrderId}/rank-wo`,
      {
        rank,
      }
    );
  }

  updateWorkOrder(id: number, body: {}): Observable<any> {
    return this.http.patch(`${this.urlRoute}/${id}/work-order`, body);
  }

  create(body: {
    quantity: number;
    workOrderId: number;
    stageName: string;
    rank: string;
  }): Observable<SubWorkOrder> {
    return this.http.post<SubWorkOrder>(`${this.urlRoute}`, body);
  }

  relocate(
    body: ApiSubWorkOrderDto['relocate']['body']
  ): Observable<SubWorkOrder> {
    return this.http.post<SubWorkOrder>(`${this.urlRoute}/relocate`, body);
  }

  quantityOnStages(
    workOrderId: number
  ): Observable<ApiSubWorkOrderDto['quantityOnStages']['res']> {
    return this.http.get<ApiSubWorkOrderDto['quantityOnStages']['res']>(
      `${this.urlRoute}/${workOrderId}/quantity-by-stage`
    );
  }

  getInspectionStatus(workOrderId: number, stageName: string): Observable<{ passed: boolean; isPending: boolean; inspectionId: number }> {
    return this.http.get<{ passed: boolean; isPending: boolean; inspectionId: number }>(`${this.urlRoute}/status/${workOrderId}/${stageName}`);
  }
}
